import { PixelRatio, View } from 'react-native';
import React from 'react';
// import { addSeconds } from 'date-fns';
import { useI18n } from '../../context/I18nContext';
import { useMapViewFilter } from '../../context/MapViewFilterContext';
import { useAuth } from '../../context/AuthContext';
import { styles } from './sharedCardConfig';
import GradientButton from '../../components/GradientButton';
// import { capitalizeFirstLetter } from '../../utils/helpers';
// import BookingCardDurationSelector from './BookingCardDurationSelector';
// import { useNowMinutes } from '../../hooks/useNow';
import { PodStatus } from '../../types/appsync-types';
import Typography from '../../components/Typography';

export const UnauthenticatedCardContent = ({
  spaceTimezone,
  minBookingMins,
  maxBookingMins,
  availabilityStatus,
  isPrepaid,
}: {
  spaceTimezone: string | undefined | null;
  minBookingMins: number | undefined;
  maxBookingMins: number | undefined;
  availabilityStatus: PodStatus | undefined;
  isPrepaid: boolean;
}) => {
  const { I18n /* , formatDateRange, formatRelative, formatDuration */ } = useI18n();
  const hasLargeFont = PixelRatio.getFontScale() > 2;

  const { logoutAsGuest } = useAuth();
  // const now = useNowMinutes();
  const { filter /* , onChange */ } = useMapViewFilter();
  // const startEnd = formatDateRange(
  //   filter.date,
  //   addSeconds(filter.date, filter.durationInSecond),
  //   'time',
  //   spaceTimezone,
  // );

  const isUnAvailable =
    minBookingMins !== undefined &&
    maxBookingMins !== undefined &&
    (filter.durationInSecond / 60 < minBookingMins * 60 || filter.durationInSecond > maxBookingMins * 60);

  let mainText: string;
  if (isUnAvailable) {
    mainText = I18n.t('mapview.podInfoCard.unavailableTitle');
  } else if (availabilityStatus === PodStatus.SUBSCRIPTION_ONLY) {
    mainText = I18n.t('mapview.podInfoCard.availableWithSubscription');
  } else {
    mainText = I18n.t('mapview.podInfoCard.available');
  }

  return (
    <>
      {/* <BookingCardDurationSelector
        pickerText={formatDuration(filter.durationInSecond, 'seconds')}
        pickerMin={minBookingMins}
        pickerMax={maxBookingMins}
        pickerValue={filter.durationInSecond / 60}
        pickerStep={60}
        onValueChange={(newValue) =>
          onChange({
            ...filter,
            durationInSecond: newValue * 60,
          })
        }
        caption={
          isPrepaid
            ? `${capitalizeFirstLetter(
                formatRelative(filter.date, now, spaceTimezone, CARD_DATE_FMT_OPTS),
              )}\n${startEnd}`
            : undefined
        }
        mainText={mainText}
        isPrepaid={isPrepaid}
      /> */}
      <View style={[styles.scheduleSection, { flexDirection: hasLargeFont ? 'column' : 'row' }]}>
        <View style={{ width: '100%' }}>
          <Typography variant={'h5'} style={{ textAlign: 'center' }}>
            {' '}
            {mainText}
          </Typography>
        </View>
      </View>
      <View style={{ marginTop: 10 }}>
        <GradientButton
          onPress={() => {
            logoutAsGuest();
          }}
        >
          {I18n.t('mapview.podInfoCard.loginToUse')}
        </GradientButton>
      </View>
    </>
  );
};
